import { Logo } from "components"

const Footer: React.FC = () => (
	<div className="py-8">
		<Logo />
	</div>
)
export default Footer
